import { organization } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveOrganizationRequestFailure({ uuid }) {
      const state = getState().find(({ planzone }) => planzone.uuid === uuid);

      return state ? state.request.isFailure : false;
    },
    isRetrieveOrganizationRequestPending({ uuid }) {
      const state = getState().find(({ planzone }) => planzone.uuid === uuid);

      return state ? state.request.isPending : false;
    },
    isRetrieveOrganizationRequestSuccess({ uuid }) {
      const state = getState().find(({ planzone }) => planzone.uuid === uuid);

      return state ? state.request.isSuccessful : false;
    },
    getOrganization({ uuid }) {
      const state = getState().find(({ planzone }) => planzone.uuid === uuid);

      return state ? state.organization : { ...organization, uuid: "" };
    },
  };
}

export { createSelector };
